function Reports (config, axios) {
  const { ReportsApi, PositionsApi, SessionApi, DevicesApi, GroupsApi, DriversApi, GeofencesApi } = require('traccar-api')
  this.traccar = {
    reports: new ReportsApi(config, null, axios),
    positions: new PositionsApi(config, null, axios),
    session: new SessionApi(config, null, axios),
    devices: new DevicesApi(config, null, axios),
    groups: new GroupsApi(config, null, axios),
    drivers: new DriversApi(config, null, axios),
    geofences: new GeofencesApi(config, null, axios),
    axios: axios || require('axios').default.create({ ...config.baseOptions, baseURL: config.basePath })
  }
  this.getUserData = async () => {
    return {
      user: await this.traccar.session.sessionGet().then(d => d.data),
      devices: await this.traccar.devices.devicesGet().then(d => d.data),
      groups: await this.traccar.groups.groupsGet().then(d => d.data),
      drivers: await this.traccar.drivers.driversGet().then(d => d.data),
      geofences: await this.traccar.geofences.geofencesGet().then(d => d.data),
      byGroup: false,
      allWeek: true,
      dayHours: { startTime: '00:00', endTime: '23:59' }
    }
  }
  this.speedingReport = (from, to, userData) => {
    return require('./speeding-report').createSpeedingReport(from, to, userData, this.traccar)
  }

  this.speedingReportToPDF = (userData, reportData) => {
    return require('./speeding-report').exportSpeedingReportToPDF(userData, reportData)
  }

  this.speedingReportToExcel = (userData, reportData) => {
    return require('./speeding-report').exportSpeedingReportToExcel(userData, reportData)
  }

  this.tripReport = (from, to, userData) => {
    return require('./trip-report').createTripReport(from, to, userData, this.traccar)
  }
  this.tripReportToPDF = (userData, reportData) => {
    return require('./trip-report').exportTripReportToPDF(userData, reportData)
  }
  this.tripReportToExcel = (userData, reportData) => {
    return require('./trip-report').exportTripReportToExcel(userData, reportData)
  }

  this.zoneReport = (from, to, userData) => {
    return require('./zone-report').createZoneReport(from, to, userData, this.traccar)
  }

  this.zoneReportToPDF = (userData, reportData) => {
    return require('./zone-report').exportZoneReportToPDF(userData, reportData)
  }

  this.zoneReportToExcel = (userData, reportData) => {
    return require('./zone-report').exportZoneReportToExcel(userData, reportData)
  }

  this.refuelingReport = (from, to, userData) => {
    return require('./refueling-report').createRefuelingReport(from, to, userData, this.traccar)
  }

  this.refuelingReportToPDF = (userData, reportData) => {
    return require('./refueling-report').exportRefuelingReportToPDF(userData, reportData)
  }

  this.refuelingReportToExcel = (userData, reportData) => {
    return require('./refueling-report').exportRefuelingReportToExcel(userData, reportData)
  }

  this.fuelDropReport = (from, to, userData) => {
    return require('./fuel-drop-report').createFuelDropReport(from, to, userData, this.traccar)
  }

  this.fuelDropReportToExcel = (userData, reportData) => {
    return require('./fuel-drop-report').exportFuelDropReportToExcel(userData, reportData)
  }

  this.fuelDropReportToPDF = (userData, reportData) => {
    return require('./fuel-drop-report').exportFuelDropReportToPDF(userData, reportData)
  }

  this.eventsReport = (from, to, userData) => {
    return require('./events-report').createEventsReport(from, to, userData, this.traccar)
  }

  this.eventsReportToPDF = (userData, reportData) => {
    return require('./events-report').exportSpeedingReportToPDF(userData, reportData)
  }

  this.eventsReportToExcel = (userData, reportData) => {
    return require('./events-report').exportSpeedingReportToExcel(userData, reportData)
  }

  this.fuelConsumptionReport = (from, to, userData) => {
    return require('./fuel-consumption-report').createFuelConsumptionReport(from, to, userData, this.traccar)
  }

  this.fuelConsumptionReportToPDF = (userData, reportData) => {
    return require('./fuel-consumption-report').exportFuelConsumptionReportToPDF(userData, reportData)
  }

  this.fuelConsumptionReportToExcel = (userData, reportData) => {
    return require('./fuel-consumption-report').exportFuelConsumptionReportToExcel(userData, reportData)
  }

  this.locationReport = (from, to, userData) => {
    return require('./location-report').createLocationReport(from, to, userData, this.traccar)
  }

  this.locationReportToPDF = (userData, reportData) => {
    return require('./location-report').exportLocationReportToPDF(userData, reportData)
  }

  this.locationReportToExcel = (userData, reportData) => {
    return require('./location-report').exportLocationReportToExcel(userData, reportData)
  }

  this.activityReport = (from, to, userData) => {
    return require('./activity-report').createActivityReport(from, to, userData, this.traccar)
  }

  this.activityReportToPDF = (userData, reportData) => {
    return require('./activity-report').exportActivityReportToPDF(userData, reportData)
  }

  this.activityReportToExcel = (userData, reportData) => {
    return require('./activity-report').exportActivityReportToExcel(userData, reportData)
  }

  this.kmsReport = (from, to, userData) => {
    return require('./kms-report').createKmsReport(from, to, userData, this.traccar)
  }

  this.kmsReportToPDF = (userData, reportData) => {
    return require('./kms-report').exportKmsReportToPDF(userData, reportData)
  }

  this.reportToWord = require('./word').reportToWord

  this.kmsReportToExcel = (userData, reportData) => {
    return require('./kms-report').exportKmsReportToExcel(userData, reportData)
  }

  this.vistaWasteActivityReport = (from, to, userData) => {
    return require('./custom/vistawasteActivity-report').createVistaWasteActivityReport(from, to, userData, this.traccar)
  }

  this.vistaWasteActivityReportToPDF = (userData, reportData) => {
    return require('./custom/vistawasteActivity-report').exportVistaWasteActivityReportToPDF(userData, reportData)
  }

  this.vistaWasteActivityReportToExcel = (userData, reportData) => {
    return require('./custom/vistawasteActivity-report').exportVistaWasteActivityReportToExcel(userData, reportData)
  }

  this.idleReport = (from, to, userData) => {
    return require('./idle-report').createIdleReport(from, to, userData, this.traccar)
  }
  this.idleReportToPDF = (userData, reportData) => {
    return require('./idle-report').exportIdleReportToPDF(userData, reportData)
  }
  this.idleReportToExcel = (userData, reportData) => {
    return require('./idle-report').exportIdleReportToExcel(userData, reportData)
  }

  this.machinesReport = (from, to, userData) => {
    return require('./machines-report').createMachinesReport(from, to, userData, this.traccar)
  }
  this.machinesReportToPDF = (userData, reportData) => {
    return require('./machines-report').exportMachinesReportToPDF(userData, reportData)
  }
  this.machinesReportToExcel = (userData, reportData) => {
    return require('./machines-report').exportMachinesReportToExcel(userData, reportData)
  }

  this.stopReport = (from, to, userData) => {
    return require('./stop-report').createStopReport(from, to, userData, this.traccar)
  }
  this.stopReportToPDF = (userData, reportData) => {
    return require('./stop-report').exportStopReportToPDF(userData, reportData)
  }
  this.stopReportToExcel = (userData, reportData) => {
    return require('./stop-report').exportStopReportToExcel(userData, reportData)
  }

  this.performanceReport = (from, to, userData) => {
    return require('./partnerReports/performance-report').createPerformanceReport(from, to, userData, this.traccar)
  }
  this.performanceReportToPDF = (userData, reportData) => {
    return require('./partnerReports/performance-report').exportPerformanceReportToPDF(userData, reportData)
  }
  this.performanceReportToExcel = (userData, reportData) => {
    return require('./partnerReports/performance-report').exportPerformanceReportToExcel(userData, reportData)
  }

  this.dailyUseReport = (from, to, userData) => {
    return require('./partnerReports/dailyuse-report').createDailyUseReport(from, to, userData, this.traccar)
  }
  this.dailyUseReportToPDF = (userData, reportData) => {
    return require('./partnerReports/dailyuse-report').exportDailyUseReportToPDF(userData, reportData)
  }
  this.dailyUseReportToExcel = (userData, reportData) => {
    return require('./partnerReports/dailyuse-report').exportDailyUseReportToExcel(userData, reportData)
  }

  this.gpsJumpReport = (from, to, userData) => {
    return require('./partnerReports/gpsjump-report').createGPSJumpReport(from, to, userData, this.traccar)
  }
  this.gpsJumpReportToPDF = (userData, reportData) => {
    return require('./partnerReports/gpsjump-report').exportGPSJumpReportToPDF(userData, reportData)
  }
  this.gpsJumpReportToExcel = (userData, reportData) => {
    return require('./partnerReports/gpsjump-report').exportGPSJumpReportToExcel(userData, reportData)
  }

  this.delayedStartReport = (from, to, userData) => {
    return require('./partnerReports/delayedstart-report').create(from, to, userData, this.traccar)
  }
  this.delayedStartReportToPDF = (userData, reportData) => {
    return require('./partnerReports/delayedstart-report').exportToPDF(userData, reportData)
  }
  this.delayedStartReportToExcel = (userData, reportData) => {
    return require('./partnerReports/delayedstart-report').exportToExcel(userData, reportData)
  }

  this.driverRankingReport = (from, to, userData) => {
    return require('./partnerReports/driverranking-report').create(from, to, userData, this.traccar)
  }
  this.driverRankingReportToPDF = (userData, reportData) => {
    return require('./partnerReports/driverranking-report').exportToPDF(userData, reportData)
  }
  this.driverRankingReportToExcel = (userData, reportData) => {
    return require('./partnerReports/driverranking-report').exportToExcel(userData, reportData)
  }

  this.sensorReport = (from, to, userData) => {
    return require('./sensor-report').create(from, to, userData, this.traccar)
  }
  this.sensorReportToPDF = (userData, reportData) => {
    return require('./sensor-report').exportToPDF(userData, reportData)
  }
}
module.exports = Reports
